// extracted by mini-css-extract-plugin
export default {"showScroll":"ReportsTable_showScroll__KdfPP","rotate":"ReportsTable_rotate__Bglnp"};